import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { ApiRequestPost } from "../../../../../../data/network/services/ApiRequestPost";
import { CustomButton } from "../../../../../components/customButton/CustomButton";
import { CustomInput } from "../../../../../components/customInput/CustomInput";
import CustomModal from "../../../../../components/customModal/CustomModal";
import {
  BG_COLOR,
  LIGHT_GREY_BG_MODAL,
} from "../../../../../resources/colorsManager";
import { SUCCESS } from "../../../../../resources/constantsManager";
import EditBeneficiary from "../../edit_beneficiary";
import BeneficiarySendOtp from "./BeneficiarySendOtp";
import SendMoneyBeneficiary from "./SendMoneyBeneficiary";

function AddBeneficaryIndividual({ onClose, onSuccess }) {
  const [beneficiaryname, setBeneficiaryName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [step, setStep] = useState(0);
  const [beneficiaryDetails, setBeneficiaryDetails] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const [openEditModal, setOpenEditModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const inputStyle = {
    backgroundColor: BG_COLOR,
    alignSelf: "center",
    marginBottom: 15,
    height: 50,
    width: "100%",
    boxShadow: "none",
  };

  const verifyOtp = (otp) => {
    setLoading(true);
    ApiRequestPost.verifyOtpForBeneficiary({
      otp,
    })
      .then((response) => {
        if (response.status === SUCCESS) {
          onClickSendMoney();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const sendOtp = (amount) => {
    setLoading(true);
    ApiRequestPost.sendOtpForBeneficiary({
      amount,
    })
      .then((response) => {
        if (response.status === SUCCESS) {
          setStep(2);
          enqueueSnackbar(response.message, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onClickSendMoney = () => {
    setLoading(true);
    ApiRequestPost.addBeneficiaryAndSendMoney({
      accountNumber: accountNumber,
      amount: beneficiaryDetails?.amount,
      type: beneficiaryDetails?.transferType,
      beneficiaryName: beneficiaryname,
      ifscCode: ifscCode,
    })
      .then((response) => {
        if (response.status === SUCCESS) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          onClose();
          onSuccess();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      })
      .finally((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (
      ifscCode.length === 11 &&
      accountNumber !== "" &&
      beneficiaryname !== ""
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [ifscCode, accountNumber, beneficiaryname]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      {step === 0 ? (
        <div
          style={{
            marginTop: 20,
          }}
        >
          <div>
            <p
              style={{
                fontSize: 14,
                color: "#888888",
                fontFamily: "Roboto",
              }}
            >
              Customer Basic Information
            </p>
          </div>
          <CustomInput
            value={beneficiaryname}
            onChange={(val) => {
              setBeneficiaryName(val);
            }}
            type="input"
            validator="name"
            inputStyles={{
              ...inputStyle,
            }}
            placeholder="Name as per Bank"
          />

          <CustomInput
            value={accountNumber}
            onChange={(val) => {
              setAccountNumber(val);
            }}
            type="input"
            validator="accountNumber"
            inputStyles={{
              ...inputStyle,
            }}
            placeholder="Account Number"
          />

          <CustomInput
            value={ifscCode}
            onChange={(val) => {
              setIfscCode(val);
            }}
            type="input"
            validator="ifscCode"
            inputStyles={{
              ...inputStyle,
            }}
            placeholder="IFSC Code"
            maxLength={11}
          />

          <CustomButton
            title="Next"
            styles={{
              width: "100%",
              marginTop: 40,
              border: "none",
              height: 45,
              borderRadius: 4,
            }}
            disabled={disabled}
            onClick={() => {
              setStep(1);
              setBeneficiaryDetails({
                accountNumber,
                ifscCode,
                beneficiaryname,
              });
            }}
          />
        </div>
      ) : step === 1 ? (
        <>
          <SendMoneyBeneficiary
            accountNumber={accountNumber}
            ifsc={ifscCode}
            name={beneficiaryname}
            onClickSubmit={(val) => {
              setBeneficiaryDetails({
                ...beneficiaryDetails,
                ...val,
              });
              onClickSendMoney();
              // sendOtp(val?.amount);
            }}
            loading={loading}
            onClickEdit={() => {
              setOpenEditModal(true);
            }}
          />
        </>
      ) : step === 2 ? (
        <BeneficiarySendOtp
          onClickConfirm={(otp) => {
            verifyOtp(otp);
          }}
          loading={loading}
        />
      ) : (
        <></>
      )}

      {openEditModal && (
        <CustomModal
          open={openEditModal}
          onClose={() => {
            setOpenEditModal(false);
          }}
        >
          <EditBeneficiary
            onClose={() => {
              setOpenEditModal(false);
            }}
            onClickSubmit={(val) => {
              setBeneficiaryName(val?.beneficiaryname);
              setIfscCode(val?.ifscCode);
              setAccountNumber(val?.accountNumber);
              setOpenEditModal(false);
            }}
          />
        </CustomModal>
      )}
    </div>
  );
}

export default AddBeneficaryIndividual;
